import { getCoreLevel } from '@wix/da-shared-react/pkg/publicSession/selectors';

export default state => {
  const coreLevel = getCoreLevel(state);
  switch (coreLevel) {
    case 'core_access':
    case 'core_plus':
      return 100;
    case 'core_pro':
      return 200;
    case 'core_pro_plus':
      return 500;
    case 'core_max':
      return 1000;
    default:
      return 100;
  }
};
